import { ForgeChrome } from "./forge/components/ForgeChrome";

/** VoiceForge browser studio — Suite house TTS (Kokoro / Breeze). */
export function App() {
  return (
    <div className="vf-app-shell">
      <ForgeChrome />
    </div>
  );
}
